/*********** Reduceres defined here *********/

import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/es/storage"; // default: localStorage if web, AsyncStorage if react-native

// reducers
import user from "./modules/user";
import rules from "./modules/rule";
import loader from "./modules/loader";
import logo from "./modules/logo";
import Subscription from "./modules/subscription";
import sidebar from './modules/sidebar'
import search from "./modules/search";
import chatbot from "./modules/chatbot";
import Subscription2 from "./modules/subscription2";
import ElevenLab from './modules/ElevenLab'
import vapi from './modules/Vapi'
import Twilio from './modules/TwilioSlice'
import { createBrowserHistory } from "history";

/*********** History function **************/
export const history = createBrowserHistory();

const userPersistConfig = {
  key: "admin-app",
  storage: storage,
  blacklist: ["router", "loader", "vapi", "ElevenLab", "Subscription2", "Twilio"],
};

export default persistCombineReducers(userPersistConfig, {
  router: history,
  loader,
  logo,
  user,
  rules,
  search,
  sidebar,
  chatbot,
  Subscription,
  vapi,
  chatbot,
  ElevenLab,
  Subscription2,
  Twilio,
});
